import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

interface Step2RolesProps {
    roles: any[];
    setRoles: React.Dispatch<React.SetStateAction<any[]>>;
    availableRoleOptions: any[];
    roleSearching?: boolean;
    onAddRole?: () => void;
    onRemoveRole?: (index: number) => void;
    onQuickRole?: (index: number) => void;
    readonly?: boolean;
}

export const Step2Roles: React.FC<Step2RolesProps> = ({
    roles,
    setRoles,
    availableRoleOptions,
    roleSearching = false,
    onAddRole,
    onRemoveRole,
    onQuickRole,
    readonly = false
}) => {
    const getFilteredRoleOptions = (rowIndex: number) => {
        const selectedRoleTypeIds = roles
            .filter((_, i) => i !== rowIndex)
            .map(r => r.roleTypeId)
            .filter(id => !!id);
        return availableRoleOptions.filter(opt => !selectedRoleTypeIds.includes(opt.value));
    };

    const updateRole = (index: number, roleTypeId: string) => {
        const roleOpt = availableRoleOptions.find(opt => opt.value === roleTypeId);
        const updated = [...roles];
        updated[index] = {
            ...updated[index],
            roleTypeId,
            roleTypeName: roleOpt?.label || ''
        };
        setRoles(updated);
    };

    return (
        <div>
            <div className="flex justify-content-between align-items-center mb-2">
                <h4 className="m-0">Danh sách đối tượng ký</h4>
                {!readonly && onAddRole && (
                    <Button label="Thêm đối tượng" icon="pi pi-plus" size="small" onClick={onAddRole} />
                )}
            </div>
            <DataTable value={roles} responsiveLayout="scroll" className="p-datatable-sm">
                <Column header="STT" body={(_, i) => (i?.rowIndex ?? 0) + 1} style={{ width: 50 }} />
                <Column header="Vai trò ký" body={(rowData, i) => {
                    if (readonly) return rowData.roleTypeName || rowData.roleTypeId;
                    return (
                        <div className="p-inputgroup w-full">
                            <Dropdown
                                value={rowData.roleTypeId}
                                options={getFilteredRoleOptions(i.rowIndex)}
                                filter showClear resetFilterOnHide
                                filterBy="label"
                                filterMatchMode="contains"
                                onChange={e => updateRole(i.rowIndex, e.value)}
                                placeholder="Chọn vai trò"
                                className="w-full"
                                emptyFilterMessage={roleSearching ? 'Đang tải dữ liệu...' : 'Không tìm thấy kết quả'}
                                loading={roleSearching}
                            />
                            {onQuickRole && (
                                <Button
                                    icon="pi pi-plus"
                                    className="p-button-secondary"
                                    tooltip="Thêm nhanh vai trò"
                                    onClick={() => onQuickRole(i.rowIndex)}
                                />
                            )}
                        </div>
                    );
                }} />
                {!readonly && onRemoveRole && (
                    <Column header="Thao tác" style={{ width: 80 }} body={(_, i) => (
                        <Button icon="pi pi-trash" severity="danger" text onClick={() => onRemoveRole(i.rowIndex)} />
                    )} />
                )}
            </DataTable>
        </div>
    );
};
